import { connect } from "react-redux";
import FrontPage from "../components/FrontPage";
import { clearLoginStatus } from "../actions/loginActions";

function mapStateToProps( state, ownProps ) {
    return {
        loggedIn: state.user.bearerToken ? true : false,
        user:state.user.data,
        
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        clearStatus: () => dispatch( clearLoginStatus() )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( FrontPage );